var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11686_787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.167 0H8.95856C7.0684 0 5.40875 1.55495 5.40875 3.39551V37.7278C5.40875 38.3439 5.58023 38.8574 5.85658 39.2541C6.01713 39.4853 6.23149 39.674 6.48117 39.8039C6.73086 39.9339 7.00839 40.0012 7.28986 40C7.82937 40 8.40378 39.7599 8.93423 39.3068L19.3177 30.4907C19.6384 30.2168 20.099 30.0598 20.578 30.0598C21.0568 30.0598 21.5165 30.2168 21.8381 30.4915L32.1868 39.3054C32.7192 39.7599 33.254 40.0002 33.7925 40.0002C34.7033 40.0002 35.591 39.2977 35.591 37.728V3.39551C35.591 1.55495 34.0572 0 32.167 0Z",
    fill: "url(#paint0_linear_11686_787)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11686_787",
    x1: 9.20065,
    y1: 0.784172,
    x2: 42.2663,
    y2: 20.2358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83DEFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11686_787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingFilters);
export default __webpack_public_path__ + "static/media/saving_filters.3b48465d35a52e1103d5365f4b919757.svg";
export { ForwardRef as ReactComponent };